import React from 'react';
import { Link } from 'react-router-dom';
import PatronAssetsContainer from 'containers/PatronAssetsContainer';
import HomepageButton from '../../HomepageButton';
import './RewardsAwait.css';

function Score({ patronAssets }) {
  const { sapphires } = patronAssets;
  return (
    <div className="rewards-await-wrapper">
      <div className="rewards-await-panel">
        <div className="rewards-await-sub-title">Rewards</div>
        <div className="rewards-await-title">Your rewards await!</div>
        <div className="rewards-await-content">
          You have {sapphires} 💎 sapphires, discover what you can redeem today.
        </div>
        <Link to="wstore">
          <HomepageButton title="Shop Now" />
        </Link>
      </div>
    </div>
  );
}

const RewardsAwait = () => {
  return (
    <PatronAssetsContainer>
      <Score />
    </PatronAssetsContainer>
  );
};

export default RewardsAwait;
